import { Component , TemplateRef, ViewChild, PLATFORM_ID ,Inject, OnInit,EventEmitter,Output} from '@angular/core';
import { CommonModule,isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { MatDialogModule,MAT_DIALOG_DATA,MatDialogRef } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

import { ProyectosService } from '../../services/proyectos.service';

import { MatDialog } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-project-remove',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    FormsModule],
  templateUrl: './project-remove.component.html',
  styleUrl: './project-remove.component.css'
})
export class ProjectRemoveComponent {
  shareLink: string;
  buttonText: string = 'Copy Text';
  buttonImage: string = '';
  buttonTextColor: string = '#EEA21A'; // Color inicial

  constructor(
    public dialogRef: MatDialogRef<ProjectRemoveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clipboard: Clipboard,
    public proyectoService: ProyectosService
  ) {
    this.shareLink = data.shareLink;
  }

 deleteProyect() { 
  // Cerrar el diálogo y pasar true como resultado 
  this.dialogRef.close(true);}
  
}
